(function () {
  var MOBILE_BP = 1024;
  var tickQueued = false;
  var scrollQueued = false;
  var headerRuntime = {
    enabled: false,
    hidden: false,
    lastScrollY: 0,
    hoverRevealZone: 72
  };

  function ensureHeaderScrollStyles() {
    if (document.getElementById('cp-header-scroll-styles')) return;
    var style = document.createElement('style');
    style.id = 'cp-header-scroll-styles';
    style.textContent = [
      'html.cp-header-scroll-enabled #shopify-section-top-bar[data-cp-hideable-topbar],',
      'html.cp-header-scroll-enabled .t4s-section-header[data-cp-hideable-header]{',
      '  transition: transform 0.45s ease-in-out, opacity 0.2s ease-in-out;',
      '  will-change: transform;',
      '}',
      'html.cp-header-scroll-hidden #shopify-section-top-bar[data-cp-hideable-topbar]{',
      '  transform: translate3d(0, calc(-100% - 2px), 0) !important;',
      '}',
      'html.cp-header-scroll-hidden .t4s-section-header[data-cp-hideable-header]{',
      '  transform: translate3d(0, calc(-100% - var(--cp-topbar-height, 0px) - 2px), 0) !important;',
      '}',
      'html.cp-header-scroll-hidden #shopify-section-top-bar[data-cp-hideable-topbar],',
      'html.cp-header-scroll-hidden .t4s-section-header[data-cp-hideable-header]{',
      '  pointer-events: none;',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function getVisibleHeight(el) {
    if (!el) return 0;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none') return 0;
    return el.offsetHeight || 0;
  }

  function setHeaderHidden(hidden) {
    if (!headerRuntime.enabled && hidden) return;
    if (headerRuntime.hidden === hidden) return;
    headerRuntime.hidden = hidden;
    document.documentElement.classList.toggle('cp-header-scroll-hidden', hidden);
  }

  function isGeoModalOpen() {
    var modal = document.getElementById('redirectModal');
    if (!modal) return false;
    if (modal.classList.contains('is-open')) return true;
    if (modal.getAttribute('aria-hidden') === 'false') return true;
    return window.getComputedStyle(modal).display !== 'none';
  }

  function measureHeaderStack() {
    var root = document.documentElement;
    var header = document.querySelector('.t4s-section-header');
    var topBar = document.getElementById('shopify-section-top-bar');

    if (!header) {
      headerRuntime.enabled = false;
      headerRuntime.hidden = false;
      root.classList.remove('cp-header-scroll-enabled', 'cp-header-scroll-hidden');
      return;
    }

    ensureHeaderScrollStyles();
    header.setAttribute('data-cp-hideable-header', '');
    if (topBar) {
      topBar.setAttribute('data-cp-hideable-topbar', '');
    }

    var topBarHeight = getVisibleHeight(topBar);
    var headerHeight = getVisibleHeight(header);
    headerRuntime.hoverRevealZone = Math.max(24, topBarHeight + headerHeight + 8);
    root.style.setProperty('--cp-topbar-height', topBarHeight + 'px');
    root.classList.add('cp-header-scroll-enabled');
    headerRuntime.enabled = true;
  }

  function runHeaderScrollLogic() {
    if (!headerRuntime.enabled) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var delta = y - headerRuntime.lastScrollY;

    if (isGeoModalOpen()) {
      setHeaderHidden(false);
      headerRuntime.lastScrollY = y;
      return;
    }

    if (y <= 8) {
      setHeaderHidden(false);
      headerRuntime.lastScrollY = y;
      return;
    }

    if (Math.abs(delta) < 6) return;

    if (delta > 0 && y > 110) {
      setHeaderHidden(true);
    } else if (delta < 0) {
      setHeaderHidden(false);
    }

    headerRuntime.lastScrollY = y;
  }

  function scheduleScroll() {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(function () {
      scrollQueued = false;
      runHeaderScrollLogic();
    });
  }

  function hideMobileToolbar() {
    document.querySelectorAll('#shopify-section-toolbar_mobile, .t4s-toolbar-mobile, .t4s-toolbar').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function ensureLeftActions(header) {
    var leftCol = header.querySelector('[data-header-height] > .t4s-col-md-4.t4s-col-3.t4s-d-lg-none.t4s-col-item');
    if (!leftCol) return;

    var leftActions = leftCol.querySelector('.t4s-mobile-left-actions');
    if (!leftActions) return;
    var leftSearch = leftActions.querySelector('.t4s-mobile-search-btn');
    if (!leftSearch) {
      var search = document.createElement('a');
      search.className = 't4s-pr t4s-mobile-search-btn';
      search.setAttribute('aria-label', 'Click To Search');
      search.setAttribute('href', '/search');
      search.setAttribute('data-drawer-delay-', '');
      search.setAttribute('data-drawer-options', '{ "id":"#t4s-search-hidden" }');
      search.innerHTML = '<svg class="t4s-icon t4s-icon--search" aria-hidden="true" focusable="false" role="presentation"><use href="#icon-h-search"></use></svg>';
      leftActions.appendChild(search);
      leftSearch = search;
    }
    leftSearch.style.setProperty('display', 'flex', 'important');
    leftSearch.style.setProperty('visibility', 'visible', 'important');
    leftSearch.style.setProperty('pointer-events', 'auto', 'important');
  }

  function ensureMobileRightIcons(header) {
    var search = header.querySelector('.t4s-col-group_btns .t4s-site-nav__search');
    var account = header.querySelector('.t4s-col-group_btns .t4s-site-nav__account');
    var cart = header.querySelector('.t4s-col-group_btns .t4s-site-nav__cart');
    var heart = header.querySelector('.t4s-col-group_btns .t4s-site-nav__heart');

    [account, cart].forEach(function (el) {
      if (!el) return;
      el.classList.remove('t4s-d-none', 't4s-d-md-inline-block');
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
    });

    if (search) {
      search.style.setProperty('display', 'none', 'important');
      search.style.setProperty('visibility', 'hidden', 'important');
      search.style.setProperty('pointer-events', 'none', 'important');
    }

    if (heart) {
      heart.style.setProperty('display', 'none', 'important');
      heart.style.setProperty('visibility', 'hidden', 'important');
      heart.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function enforceMobileHeader() {
    if (window.innerWidth > MOBILE_BP) return;
    var header = document.querySelector('.t4s-section-header');
    if (!header) return;
    ensureLeftActions(header);
    ensureMobileRightIcons(header);
  }

  function openLocalizationPanel() {
    var panel = document.querySelector('[data-cp-loc-panel]');
    var overlay = document.querySelector('[data-cp-loc-overlay]');
    var fab = document.querySelector('[data-cp-loc-fab]');
    if (!panel || !overlay || !fab) return false;
    panel.style.display = 'block';
    overlay.style.display = 'block';
    fab.setAttribute('aria-expanded', 'true');
    return true;
  }

  window.CPFooterLocOpen = openLocalizationPanel;

  function tick() {
    var root = document.documentElement;
    var isMobile = window.innerWidth <= MOBILE_BP;
    if (isMobile) {
      root.classList.remove('cp-header-scroll-enabled', 'cp-header-scroll-hidden');
      headerRuntime.enabled = false;
      headerRuntime.hidden = false;
      hideMobileToolbar();
      enforceMobileHeader();
      return;
    }

    measureHeaderStack();
    headerRuntime.lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (isGeoModalOpen()) {
      setHeaderHidden(false);
    }
  }

  function schedule() {
    if (tickQueued) return;
    tickQueued = true;
    requestAnimationFrame(function () {
      tickQueued = false;
      tick();
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-cp-footer-loc-trigger]') : null;
    if (!trigger) return;
    e.preventDefault();
    openLocalizationPanel();
  }, true);

  document.addEventListener('DOMContentLoaded', tick);
  window.addEventListener('load', tick);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', scheduleScroll, { passive: true });
  window.addEventListener('mousemove', function (e) {
    if (!headerRuntime.hidden) return;
    if (e.clientY <= headerRuntime.hoverRevealZone) {
      setHeaderHidden(false);
    }
  }, { passive: true });

  var mobileObserver = null;
  function manageMobileObserver() {
    var isMobile = window.innerWidth <= MOBILE_BP;
    if (!isMobile) {
      if (mobileObserver) {
        mobileObserver.disconnect();
        mobileObserver = null;
      }
      return;
    }
    if (mobileObserver) return;
    var observerRoot = document.body || document.documentElement;
    if (!observerRoot) return;
    mobileObserver = new MutationObserver(function () {
      schedule();
    });
    mobileObserver.observe(observerRoot, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', manageMobileObserver, { once: true });
  } else {
    manageMobileObserver();
  }

  // Defensive periodic enforcement against late mobile script mutations.
  setInterval(function () {
    if (document.hidden) return;
    if (window.innerWidth <= MOBILE_BP) tick();
  }, 2000);

  window.addEventListener('resize', manageMobileObserver, { passive: true });
})();
